module.exports = __webpack_public_path__ + "img/SmartInterface_einfarbig_RGB.1fa1c36d.svg";